<template>
  <div>
    <PricingFilterToolbar
      :show-search="false"
      :expired-filter="expiredFilter"
      @expired-filter-change="expiredFilter = $event"
    >
      <template v-slot:actions>
        <button v-if="userEditRight" @click="addNewTopup()" type="button" class="btn btn-info mr-3 mb-2">
          Add New Topup Package
        </button>
      </template>
    </PricingFilterToolbar>
    <div class="table-responsive table-bordered" v-if="packages.length > 0">
      <table class="table pricing-table">
        <thead>
          <tr class="text-nowrap">
            <th class="pricing-column-description">Description</th>
            <th class="pricing-column-size">Size</th>
            <th class="pricing-column-price">NRC (excl. VAT)</th>
            <th class="pricing-column-price">NRC (incl. VAT)</th>
            <th class="pricing-column-status">Expired</th>
            <th class="pricing-column-actions">Commands</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(topupPackage, rowIndex) in packages" :key="rowIndex">
            <td>{{ topupPackage.description }}</td>
            <td>{{ topupPackage.size }} GB</td>
            <td>
              {{ getPrice(topupPackage.axxessltetopupprices, period) }}
              <span
                v-if="userEditRight"
                style="cursor: pointer"
                v-tooltip="'Edit Row Price'"
                @click="openPriceModal(topupPackage)"
                class="pull-right"
              >
                <em class="fa fa-edit fa-fw text-green"></em>
              </span>
            </td>
            <td>
              {{ getPrice(topupPackage.axxessltetopupprices, period, true) }}
            </td>
            <td>
              <span
                class="badge"
                :class="topupPackage.expired ? 'badge-warning' : 'badge-green'"
                >{{ topupPackage.expired }}
              </span>
            </td>
            <td class="text-center">
              <button
                v-if="userEditRight"
                v-tooltip="'Edit Topup'"
                @click="editTopup(topupPackage)"
                type="button"
                class="btn btn-sm btn-info m-1"
              >
                <em class="fa fa-edit fa-fw"></em>
              </button>
              <button
                v-if="userEditRight"
                v-tooltip="'Delete Topup'"
                @click="deleteTopup(topupPackage)"
                type="button"
                class="btn btn-sm btn-primary"
              >
                <em class="fa fa-trash fa-fw"></em>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="alert alert-info col-sm-12" v-else>
      No topup packages to display
    </div>
    <AddPriceModal
      ref="addPriceModal"
      :row-price="rowPrice"
      :new-price="newPrice"
      @addPrice="addPrice"
      @pricesAdded="getAxxessTopups()"
    />
    <AxxessPriceModal
      ref="modifyTopupModal"
      :pricePackage="axxessTopupPrice"
      :availableAxxessProducts="availableTopups"
      :isTopup="true"
      @save-price="saveTopupPackage"
      :supplier="productSupplier"
    />
  </div>
</template>

<script>
import AddPriceModal from "@/components/Admin/Modals/AddPriceModal";
import AxxessPriceModal from "@/components/Admin/Modals/AxxessPriceModal";
import PricingFilterToolbar from "@/components/Admin/PricingFilterToolbar";
import PriceFunctions from "@/components/Admin/PriceFunctions";
import { getProduct } from "@/api/v1/products.api";

export default {
  extends: PriceFunctions,
  props: {
    productNumber: {
      type: Number,
      required: true,
    },
    productSupplier: {
      type: String,
      required: true,
    },
    userEditRight: {
      type: Boolean,
      required: true
    },
  },
  components: {
    AddPriceModal,
    AxxessPriceModal,
    PricingFilterToolbar,
  },
  data() {
    return {
      period: this.getCurrentPeriod(),
      newPrice: {},
      axxessTopupPrice: {},
      rowPrice: [],
      availableTopups: [],
      expiredFilter: 'false',
      axxesstopuppackages: [],
      filteredPackages: [],
      isMtn: false,
    };
  },
  async mounted() {
    await this.getAxxessTopups();
    await this.getAxxessAvailableTopups();
  },
  computed: {
    packages() {  
      if (this.expiredFilter === 'true') {
        this.filteredPackages = this.axxesstopuppackages.filter(p => p.expired === true);
      } else if (this.expiredFilter === 'both') {
        this.filteredPackages = this.axxesstopuppackages;
      } else {
        this.filteredPackages = this.axxesstopuppackages.filter(p => p.expired === false);
      }
      
      return this.filteredPackages;
    },
  },
  methods: {
    getAxxessTopups() {
      this.$http
        .get(
          this.$config.aimsAPI + "pricing/axxesstopups/" + this.productNumber
        )
        .then(
          (response) => {
            this.axxesstopuppackages = response.data;
          },
          (error) => {
            this.showError("Error fetching Axxess Topups", error);
            console.error(error);
          }
        );
    },
    getAxxessAvailableTopups() {
      getProduct(this.productNumber).then((res) => {
        this.$http.get(this.$config.aimsAPIv2 + 'vendors/' + res.data.vendorNumber)
          .then(response => {
            if (response.body.skuName == "MTN") {
              this.isMtn = true;
              this.$http.get(this.$config.aimsAPI + "axxess/lte/mtn/availabletopups")
                .then(
                  (response) => {
                    this.availableTopups = response.data;
                  },
                  (error) => {
                    this.showError("Error fetching Available Axxess Products", error);
                    console.error(error);
                  }
                );
            } else {
              this.$http.get(this.$config.aimsAPI + "axxess/lte/telkom/availabletopups")
                .then(
                  (response) => {
                    this.availableTopups = response.data;
                  },
                  (error) => {
                    this.showError("Error fetching Available Axxess Topups", error);
                    console.error(error);
                  }
                );
            }
          });
      })
    },
    addNewTopup() {
      this.axxessTopupPrice = this.deepCopyObject({
        class: "za.co.adept.aims.axxess.lte.AxxessLteTopup",
        productNumber: this.productNumber,
      });
      this.$refs.modifyTopupModal.open();
    },
    editTopup(topupPackage) {
      this.axxessTopupPrice = this.deepCopyObject(topupPackage);
      this.$refs.modifyTopupModal.open();
    },
    openPriceModal(topupPackage) {
      this.rowPrice = this.deepCopyObject(topupPackage.axxessltetopupprices);
      this.newPrice = this.deepCopyObject({
        axxessLteTopupNumber: topupPackage.axxessLteTopupNumber,
        class: topupPackage.class + "Price",
        validFrom: 0,
        validUntil: 0,
      });
      this.$refs.addPriceModal.open();
    },
    addPrice(newPrice) {
      this.rowPrice.forEach((price) => {
        if (price.validUntil == 0) {
          if (newPrice.validFrom % 100 > 1) {
            price.validUntil = newPrice.validFrom - 1;
          } else {
            price.validUntil = newPrice.validFrom - 100 + 11;
          }
        }
      });
      this.rowPrice.push(newPrice);
      this.newPrice = this.deepCopyObject({
        axxessLteTopupNumber: newPrice.axxessLteTopupNumber,
        class: newPrice.class,
        validFrom: 0,
        validUntil: 0,
      });
    },
    saveTopupPackage(topupPackage) {
      this.$http
        .post(this.$config.aimsAPI + "pricing/pricepackages/save", topupPackage)
        .then(
          (response) => {
            this.showSuccess("Updated Axxess LTE Topup Successfully");
            if (topupPackage.axxessLteTopupNumber) {
              this.getAxxessTopups();
            } else {
              response.data.axxessltetopupprices = [];
              this.openPriceModal(response.data);
            }
          },
          (error) => {
            this.showError("Error Saving Pricing", error);
            console.error(error);
          }
        );
    },
    deleteTopup(pricePackage) {
      this.$swal({
        title: "Are you sure you want to delete topup price package?",
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(
              this.$config.aimsAPI +
                "pricing/pricepackages/" +
                pricePackage.objKey +
                "?objClassName=" +
                pricePackage.class
            )
            .then(
              () => {
                this.showSuccess("Successfully deleted topup price");
                this.getAxxessTopups();
              },
              (error) => {
                this.showError("Error Deleting Topup Pricing Package", error);
              }
            );
        }
      });
    },
  },
};
</script>

<style scoped>
th.table-font-size {
  font-size: .95rem;
}
th.table-header-width-1 {
  width: 10px;
}
th.table-header-width-2 {
  width: 20px;
}
th.table-header-width-3 {
  width: 50px;
}
th.table-header-width-4 {
  width: 60px;
}
th.table-header-width-5 {
  width: 95px;
}
th.table-header-width-6 {
  width: 200px;
}

.font-size {
  font-size: .9rem;
}
</style>